import styled from "styled-components";

import { Grid } from "@mui/material";
import BannerImg from "../../assets/cangoo-contato-banner.jpg"

export const BannerGrid = styled(Grid)`

background: url(${BannerImg});
background-repeat: no-repeat;
background-position: top right; 
background-size: cover; 

padding-top: 24rem;
padding-bottom: 10rem;

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.title {
    position: relative;
    width: fit-content;
    display: flex;
    
    margin-left: 10rem;
    animation: fadeIn 2s ease-in-out;

    h1 {
        font-family: 'Nexa-Black'; 
        font-size: 8rem;
        color: ${({ theme }) => theme.COLORS.WHITE};
        letter-spacing: 1px;
        padding-right: 4rem;
        padding-bottom: 2rem;
    }

    img {
        width: 15rem;
        position: absolute;
        right: 0;
      
    }
}


@media (max-width: 1400px) {
   .title {

    h1 { 
        font-size: 5rem;
        padding-right: 3rem;
        
    }

    img {
        width: 10rem;  
        bottom: 0;
    }
   }
  }
 
  @media (max-width: 900px) {
    padding-top: 20rem;
    padding-bottom: 6rem;

    .title {
    margin-left: auto;
    margin-right: auto;
  
    h1 { 
        font-size: 4rem;
        padding-right: 3rem;
        padding-bottom: 2rem;
    }

    img {
        width: 8rem;  
    }
   }
  }
`;


export const ContatoGrid = styled(Grid)`
display: flex;
align-items: center;
padding: 10rem 0;
animation: fadeIn 1s ease-in-out;


.sideA {
  position: relative;
  display: flex;
  align-items: center;

  .informacoes-bg {
    position: absolute;
    width:  clamp(47rem, 45vw, 76rem);
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: -1;
  }

  .informacoes {
    color: ${({ theme }) => theme.COLORS.WHITE};
    max-width: 44rem;
    margin-left: 14rem;

    .endereco {
      display: flex;
      align-items: center;
      margin-bottom: 1.6rem;
      gap: 1rem;
    }

    h1 {
      font-family: 'Mont-Bold';
      font-size: clamp(2rem, 2vw, 3rem);
    }

    h1:nth-child(2):hover {
        color: ${({ theme }) => theme.COLORS.YELLOW};
    }

    h1:nth-child(3), h1:nth-child(5) {
      margin-top: 3.6rem;
      margin-bottom: 1.6rem;
    }

    p, span {
        font-family: 'Mont-Light';
        font-size: clamp(1.8rem, 2vw, 2.4rem);
        color: ${({ theme }) => theme.COLORS.WHITE};
    }

    span {
      cursor: pointer;
    }
 
    span:hover {
      color: ${({ theme }) => theme.COLORS.YELLOW};
    }

    li {
      margin-bottom: 1.2rem;
      display: flex;
      align-items: center;
      gap: 1rem;
      
    }


    .redes-sociais {
      img:hover {
        scale: 1.06;
      }
    }
  }

}

.sideB {
    max-width: 80rem;
    padding-right: 4rem;


    .form-content {
      padding: 0;
    }

  .form-text {
    margin-bottom: 2rem;

    h1 {
        font-size: clamp(2.4rem, 3.4vw, 5rem); 
        font-family: 'Nexa-Bold';
        margin-bottom: 1.8rem;
        letter-spacing: 1px;
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
    }

    p {
        font-family: 'Mont-Light';
        font-size: clamp(1.6rem, 3.4vw, 3rem); 
    }
}

}

@media (max-width: 1560px) {
  .sideA {

    .icon {
     height: clamp(1.8rem, 1.6vw, 2rem);;
    }
 
  .informacoes {
    margin-left: 5rem;

    .endereco {
      margin-bottom: 1rem;
    }

    h1 {
      font-family: 'Mont-Bold';
      font-size: clamp(1.8rem, 1.6vw, 2rem);
    }

    h1:nth-child(3), h1:nth-child(5) {
      margin-top: 1.8rem;
      margin-bottom: 1rem;
    }

    p, span {
        font-size: clamp(1.5rem, 1.6vw, 1.8rem);
    }

    li {
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      gap: 1rem;
      
    }

  }

}
}


@media (max-width: 1400px) {
  .sideB {
   padding-left: 4rem;
   padding-right: 8rem;

  .form-text {

    h1 {
        font-size: clamp(2.6rem, 3.4vw, 4.2rem); 
        margin-bottom: 1rem;
    }

    p {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
    }
}

}

}

@media (max-width: 1245px) {
  .sideA .informacoes {
    margin-left: 5rem;
    max-width: 36rem;
  }
}


@media (max-width: 900px) {
padding: 0;

  .sideA {
      background: ${({ theme }) => theme.COLORS.BACKGROUND_BLUE};
      height: auto;
      padding: 6rem 2rem;

      .informacoes {
        margin-left: auto;
        margin-right: auto;

      }

    .informacoes-bg {
       display: none;
    }
  }

    .sideB {
      padding: 6rem 4rem;
      text-align: center;
      margin-left: auto;
      margin-right: auto;

      .form-content {
    padding-right: 0 !important;
    padding-left: 0 !important;
   }

   .form-text h1 {
    line-height: 4rem;
   }
    }
}


@media (max-width: 600px) {
  .sideB {
      padding: 6rem 2rem;
    }
}
`;


export const OutsideLink = styled.a`
 text-decoration: none !important;
`;


export const Address = styled.div`
   font-family: 'Mont-Bold'; 
 
  h1 {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.COLORS.YELLOW};
  }
  
  p {
    
    font-size: 1.2rem;
  }
`;
